<script lang="ts">
    import ImageGalleryRow from "./ImageGalleryRow.svelte"

    let {
        block,
    }: {
        block: ImageGalleryBlock
    } = $props()
    const cnt = block.content
</script>

<section class="gallery" class:noText={cnt.notext}>
    {#each cnt.rows as o}
        <ImageGalleryRow {...o} />
    {/each}
</section>

<style lang="less" global>
    @import "../../../../css/variables.less";
    .gallery {
        display: flex;
        flex-direction: column;
        gap: var(--default-padding);

        
        &.noText {
            padding: 0;
        }
        width: 100%;
        align-items: center;
        overflow: hidden;
        .gallery-row {
            display: flex;
            justify-content: space-between;
            gap: 2.4rem;
            width: 100%;
            max-width: var(--extended-max-width);
            &.items-2 {
                .gallery-item {
                    max-width: 712px;
                    width: 100%;
                }
            }
            .gallery-item {
                flex-grow: 1;
                display: flex;
                gap: 2.4rem;
                &.large {
                    img {
                        max-width: 1016px;
                    }
                }
                &.bottom {
                    flex-direction: column;
                    img {
                        max-width: unset !important;
                        width: 100%;
                    }
                }
                &.left {
                    flex-direction: row-reverse;
                }
                &.right {
                    flex-direction: row;
                }
                picture,
                img {
                    height: 472px;
                    width: 100%;
                    border-radius: 4px;
                    object-fit: cover;
                }
                &.right,
                &.left {
                    align-items: flex-end;
                    picture,
                    img {
                        width: 100%;
                        max-width: 1016px;
                        flex-grow: 1;
                        object-fit: cover;
                    }
                }
                .text {
                    height: fit-content;
                    max-width: 712px;
                    white-space: pre-line;
                }
            }
            &.items-1 {
                .gallery-item {
                    picture {
                        height: auto;
                        img {
                            height: auto;
                        }
                    }
                    .text {
                        max-width: 100%;
                    }
                }
            }
            &.items-2 {
                .text {
                    max-width: 100%;
                }
            }
            @media (max-width: 1600px) {
                flex-direction: column;
                align-items: center;
                .gallery-item {
                    width: 100%;
                    display: flex;
                    align-items: center !important;
                    max-width: unset !important;
                    img {
                        max-width: unset !important;
                        width: 100%;
                    }
                    p {
                        width: 100%;
                    }
                    &.left,
                    &.right {
                        flex-direction: column;
                    }
                }
            }
        }

        &.noText {
            overflow: unset;
            .gallery-item {
                max-width: unset !important;
            }
            picture {
                width: 100% !important;
                overflow: hidden;
                height: unset !important;
                img {
                    object-fit: contain !important;
                    height: auto !important;
                    width: 100% !important;
                    max-width: 100% !important;
                    @media (max-width: 1600px) {
                        width: 100% !important;
                    }
                }
            }
            .text {
                display: none !important;
            }
        }
    }
</style>
